// Photos supplied with the client redesign take priority over the
// per-destination photos in public/images/destinations/{card,hero}/<ISO3>.webp.
const REDESIGN_CARDS = {
  USA: 'dest-us',
  JPN: 'dest-japan',
  EU: 'dest-europe',
  THA: 'dest-thailand',
  GBR: 'dest-uk',
  MEX: 'dest-mexico',
  CAN: 'dest-canada',
  BRA: 'dest-brazil',
  ITA: 'dest-italy',
  GRC: 'dest-greece',
  ARE: 'dest-uae'
};

const REDESIGN_HEROES = {
  USA: 'hero-us',
  CAN: 'hero-canada',
  BRA: 'hero-brazil',
  GRC: 'hero-greece',
  ARE: 'hero-uae'
};

const DESTINATION_PHOTOS = new Set([
  'ABW', 'AFG', 'AGO', 'AIA', 'ALB', 'AND', 'ANT', 'ARE', 'ARG', 'ARM', 'ATG', 'AUS',
  'AUT', 'AZE', 'BEL', 'BEN', 'BFA', 'BGD', 'BGR', 'BHR', 'BHS', 'BIH', 'BLM', 'BLR',
  'BLZ', 'BMU', 'BOL', 'BRA', 'BRB', 'BRN', 'BTN', 'BWA', 'CAF', 'CAN', 'CHE', 'CHL',
  'CHN', 'CIV', 'CMR', 'COD', 'COG', 'COL', 'CPV', 'CRI', 'CUB', 'CUW', 'CYM', 'CYP',
  'CZE', 'DEU', 'DMA', 'DNK', 'DOM', 'DZA', 'ECU', 'EGY', 'ESP', 'EST', 'ETH', 'EU',
  'FIN', 'FJI', 'FLK', 'FRA', 'FRO', 'GAB', 'GBR', 'GEO', 'GGY', 'GHA', 'GIB', 'GIN',
  'GLP', 'GMB', 'GNB', 'GNQ', 'GRC', 'GRD', 'GRL', 'GTM', 'GUF', 'GUM', 'GUY', 'HKG',
  'HND', 'HRV', 'HTI', 'HUN', 'IDN', 'IMN', 'IND', 'IRL', 'IRN', 'IRQ', 'ISL', 'ISR',
  'ITA', 'JAM', 'JEY', 'JOR', 'JPN', 'KAZ', 'KEN', 'KGZ', 'KHM', 'KIR', 'KNA', 'KOR',
  'KSV', 'KWT', 'LAO', 'LBN', 'LBR', 'LBY', 'LCA', 'LIE', 'LKA', 'LSO', 'LTU', 'LUX',
  'LVA', 'MAC', 'MAF', 'MAR', 'MCO', 'MDA', 'MDG', 'MDV', 'MEX', 'MKD', 'MLI', 'MLT',
  'MMR', 'MNE', 'MNG', 'MNP', 'MOZ', 'MRT', 'MSR', 'MTQ', 'MUS', 'MWI', 'MYS', 'MYT',
  'NAM', 'NER', 'NGA', 'NIC', 'NLD', 'NOR', 'NPL', 'NRU', 'NZL', 'OMN', 'PAK', 'PAN',
  'PER', 'PHL', 'PLW', 'PNG', 'POL', 'PRI', 'PRT', 'PRY', 'PSE', 'PYF', 'QAT', 'REU',
  'ROU', 'RUS', 'RWA', 'SAU', 'SDN', 'SEN', 'SGP', 'SLE', 'SLV', 'SMR', 'SRB', 'SSD',
  'SUR', 'SVK', 'SVN', 'SWE', 'SWZ', 'SYC', 'TCA', 'TCD', 'TGO', 'THA', 'TJK', 'TLS',
  'TON', 'TTO', 'TUN', 'TUR', 'TWN', 'TZA', 'UGA', 'UKR', 'URY', 'USA', 'UZB', 'VAT',
  'VCT', 'VEN', 'VGB', 'VIR', 'VNM', 'VUT', 'WSM', 'ZAF', 'ZMB', 'ZWE'
]);

const url = (path) => window.getPublicUrl(path);

// Card-sized photo (≈560px) or null when we only have the flag.
export const getDestinationCardImage = (iso3) => {
  if (REDESIGN_CARDS[iso3]) return url(`images/r4l/${REDESIGN_CARDS[iso3]}.webp`);
  if (DESTINATION_PHOTOS.has(iso3)) return url(`images/destinations/card/${iso3}.webp`);
  return null;
};

// Wide hero photo (≈1440px); falls back to the generic home hero.
export const getDestinationHeroImage = (iso3) => {
  if (REDESIGN_HEROES[iso3]) return url(`images/r4l/${REDESIGN_HEROES[iso3]}.webp`);
  if (DESTINATION_PHOTOS.has(iso3)) return url(`images/destinations/hero/${iso3}.webp`);
  return url('images/r4l/hero.webp');
};

